export enum ProviderSpecificType {
  SportBooks = 1,
  Casino = 2,
}

export enum BonusStatuses {
  Scheduled = 0,
  Active = 1,
  Canceled = 2,
  PromotionCanceled = 3,
  Finished = 4,
  PartialCancelled = 5,
  Pending = 6,
  InProcess = 7,
}

export enum PlayerComplaintCategories {
  GameBettingOdds = 1,
  Cancellation = 2,
  Exclusion = 3,
  Winnings = 4,
  Bonus = 5,
  IllegalConduct = 6,
  CashOut = 7,
  CommercialCommunication = 8,
  TermsOfParticipation = 9,
  GamingLimits = 10,
  PaymentsOfWinnings = 11,
  IdentificationAndVerification = 12,
  ResponsibleGaming = 13,
  AccountBlocking = 14,
  Other = 15,
}

export enum PlayerComplaintReplyChannels {
  Email = 1,
  Letter = 2,
}

export enum PlayerComplaintStatuses {
  New = 1,
  Replied = 2,
}

export enum AllBonusTypes {
  FreeBet = 101,
  WagerStandard = 102,
  WagerReal = 103,

  SportWagering = 200,
  SportFreeBet = 201,
  SportRealWagering = 202,

  RealMoney = 300,

  FreeSpin = 400,
  FreeAmount = 401,
}

export enum CampaignV2Bonuses {
  FreeBetCasino = 1,
  FreeBetSport = 2,
  WagerCombined = 3,
  RealMoney = 6,
  FreeGame = 4,
}

export enum CampaignV2BonusFamilies {
  FreeBet = 1,
  Spin = 2,
  Combined = 3,
  Special = 4,
}

export enum CampaignV2MixedBonusSubTypes {
  FreeSpin = 1,
  FreeAmount = 2,
  CombinationSpin = 4,
  Countdown = 8,
  FreeChip = 16,
}

export enum ProductTypes {
  Sport = 1,
  Casino = 2,
  Both = 3,
}

export enum BonusesTypes {
  Casino = 1,
  Sport = 2,
  Special = 3,
  Spin = 4,
}

export enum CampaignV2UseTypes {
  Common = 1,
  CrossPlatform = 2,
}

export enum CampaignV2ParticipantTypes {
  AllPlayers = 0,
  Players = 1,
  PlayersWithAmount = 2,
  PromoCode = 3,
}

export enum CampaignV2SourceTypes {
  Internal = 1,
  Optimove = 2,
  ThunderBite = 3,
}

export enum CampaignV2BonusCancellerTypes {
  Player = 1,
  System = 2,
  User = 3,
}

export enum BonusActivationTypes {
  Player = 1,
  System = 2,
}

export enum CampaignV2LockAmountTypes {
  None = 0,
  Trigger = 1,
  Full = 2,
}

export enum CampaignV2Statuses {
  Draft = 0,
  Scheduled = 1,
  Active = 2,
  // Canceled= 3,
  // PromotionCanceled= 4,
  Finished = 5,
  // PartialCancelled= 6,
  Pending = 7,
  InProcess = 8,
}

export enum CampaignV2TriggerTypes {
  NoTrigger = 0,
  SignUp = 1,
  Verify = 2,
  Deposit = 3,
  SignIn = 4,
  Bet = 5,
  GameLaunch = 6,
  Withdrawal = 7,
  AutoDepositActivation = 8,
}

export enum UnitStatuses {
  Draft = 0,
  Scheduled = 1,
  Active = 2,
  PartialCancelled = 3,
  Canceled = 4,
  Finished = 5,
}

export enum CompletedUnitStatus {
  Canceled = 4,
  Finished = 5,
}

export enum LimitationTypes {
  SelfExclusion = 0,
  Timeout = 1,
  Deposit = 2,
  Withdrawal = 3,
  Bet = 4,
  RealityCheck = 5,
  AccessLimit = 6,
  LossLimit = 7,
  SingleBet = 8,
  GameTimeLimit = 9,
  NetDeposit = 10,
}

export enum KycTypes {
  InternalDocuments = 1,
  KycAid = 2,
  MetaMap = 3,
  GhanaRegulation = 4,
  BecomeDigital = 5,
  Unico = 6,
}

export enum AffiliateTypes {
  Everymatrix = 1,
  Smartico = 2,
  Digitain = 3,
  Alanbase = 4,
  MyAffiliates = 5,
  IncomeAccess = 6,
  Raventrack = 7,
}

export enum DigitainAffiliateDataSendPeriodTypes {
  Hourly = 1,
  Daily = 2,
}

export enum LiveChatSolutionTypes {
  LiveChat = 1,
  LiveAgent = 2,
  Zendesk = 3,
  Intercom = 4,
  WhatsApp = 5,
}

export enum GamificationTypes {
  Smartico = 1,
  ThunderBite = 2,
}

export enum CrmTypes {
  Smartico = 1,
  Digitain = 2,
  Optimove = 3,
}

export enum AnalyticsTypes {
  Hotjar = 1,
  GoogleAnalytics = 2,
  GoogleSearchConsole = 3,
  GoogleAds = 4,
}

export enum RetailSolutionTypes {
  Digitain = 1,
}

export enum ArtificialIntelligenceTypes {
  ZingBrain = 1,
}

export enum ThirdPartyCodeTypeScript {
  Script = 1,
  Style = 2,
}

export enum ThirdPartyCodePosition {
  Head = 1,
  Body = 2,
}

export enum AgSolutionTypes {
  Digitain = 1,
  Everymatrix = 2,
}

export enum AuthenticationTypes {
  Firebase = 1,
  ItsMe = 2,
  Authentigate = 3,
  Trustly = 4,
}

export enum PlayerVerification {
  Email = 1,
  Mobile = 2,
  Address = 4,
  Identity = 8,
  Physical = 16,
  Citizenship = 32,
  Payment = 128,
  Edd = 256,
}

export enum BrandMarkets {
  None = 1,
  Armenia = 2,
  Malta = 3,
  Cyprus = 4,
  Greece = 5,
  Romania = 6,
  Belgium = 7,
  Columbian = 8,
  Estonia = 9,
  Ghana = 10,
  UK = 11,
  Bulgaria = 12,
  Brazil = 13,
  DominicanRepublic = 14,
  Portugal = 15,
}

export enum ThirdPartyServicesStatuses {
  NotIntegrated = 0,
  Enabled = 1,
  Disabled = 2,
}

export enum JackpotSetStatuses {
  Active = 1,
  Inactive = 2,
  Deleted = 3,
}

export enum PaymentActivities {
  Both = 0,
  Deposit = 1,
  Withdrawal = 2,
}

export enum Resource {
  BlockProviders = 1,
  AccountClosure = 2,
  BalanceAdjustment = 3,
  GameManagement = 4,
  PlayerAccountMarkAttention = 6,
  PlayersBetLimitation = 7,
  PlayersDepositLimitation = 8,
  PlayersStatusUpdate = 9,
  PlayersTimeOut = 10,
  PlayersWithdrawals = 11,
  VerticalTags = 12,
  PlayersSelfExclusion = 13,
  WithdrawalsStatusChange = 14,
  PlayersBlockControl = 16,
  PlayersLossLimitation = 18,
  PlayersSingleBetLimitation = 19,
  BlockPaymentMethods = 20,
  ExchangeMaterialPrize = 21,
  WebsiteSelfExclusion = 22,
  WebsiteAccountTimeOut = 23,
  PlayersGameTimeLimitation = 24,
}

export enum ReasonsType {
  Default = 1,
  Custom = 2,
  System = 3,
}

export enum PaymentType {
  Online = 0,
  Terminal = 1,
  Offline = 2,
  Agent = 3,
}

export enum PromotionGroupLimitPeriodType {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  AllPeriod = 4,
}

export enum NotificationPreferences {
  Deposit = 1,
  Withdrawal = 2,
  Promotion = 4,
  // eslint-disable-next-line no-shadow
  Bonuses = 8,
}

export enum SelectedPlayersErrorStatus {
  TimeOut = 1,
  InvalidKey = 2,
  MissingCurrency = 4,
  SelfExcluded = 8,
  Blocked = 16,
  BlockedInSport = 64,
  BlockedInCasino = 128,
  Deleted = 256,
  BlockForDeposit = 512,
  BlockForWithdrawal = 1024,
  BlockForUnverified = 2048,
}

export enum TagCategoryType {
  Horizontal = 1,
  Vertical = 2,
}

export enum TagContentType {
  Player = 0,
  GameContent = 1,
}

export enum QuickSearchResponseItemType {
  Player = 1,
  Deposit = 2,
  Withdrawal = 3,
  SportBet = 4,
  CasinoBet = 5,
}

export enum GameRiskTypes {
  Cashback = 1,
  FreeBet = 2,
  Wager = 3,
  Promotions = 4,
  Tournament = 5,
}

export enum ExportTypes {
  Csv = 1,
  Excel = 2,
  Summary = 3,
}

export enum AggregationCriteriaTypes {
  Daily = 1,
  Monthly = 2,
}

export enum Regulators {
  Cypriot = 4,
  Greece = 5,
  Romanian = 6,
  Estonia = 9,
  Bulgaria = 12,
  Brazil = 13,
  Portugal = 15,
}

export enum RegulatoryExclusionTypes {
  Exclusion = 1,
  SelfExclusion = 2,
}

export enum SIGAPMonthlyReportStatusTypes {
  InProgress = 1,
  Sent = 2,
  NotAccepted = 3,
  Accepted = 4,
}

export enum RegulatoryExclusionDurationCategories {
  Other = 0,
  Indefinite = 1,
  Temporary = 2,
  Hours24 = 3,
}

export enum RegulatoryExclusionChannels {
  Other = 0,
  Licensee = 1,
  HGC = 2,
}

export enum RegulatoryBetEventTypes {
  Main = 0,
  Secondary = 1,
}

export enum RegulatoryBonusCategoryA {
  RedeemableBonusSchema = 0,
  NonRedeemableBonusSchema = 1,
}

export enum RegulatoryBonusCategoryB {
  Cashback = 1,
  FreeBet = 2,
  FreeRound = 3,
  KambiFreeBet = 4,
  Standard = 5,
  Tournament = 6,
  TournamentTicket = 7,
  Wagering = 8,
}

export enum BettingEventCategories {
  PreGame = 1,
  Live = 2,
  PreGameAndLive = 3,
}

export enum BettingPerformanceBetTypes {
  Single = 1,
  Parlay = 2,
  Multiples = 3,
  Other = 4,
}

export enum DevToolDbSyncMergeModes {
  Delta = 0,
  Full = 1,
  InsertsAndUpdates = 2,
  InsertsOnly = 3,
  UpdatesOnly = 4,
}

export enum UserClaimTypes {
  SuperAdmin = 1,
  Developer = 3,
}

export enum MessageCategories {
  Promotion = 2,
  Newsletter = 3,
  Notification = 4,
  Bonus = 5,
  Other = 1,
}

export enum Channels {
  SMS = 1,
  Email = 2,
  Inbox = 3,
  PushNotification = 4,
  WhatsApp = 6,
}

export enum MagicLinkChannels {
  SMS = Channels.SMS,
  Email = Channels.Email,
  WhatsApp = Channels.WhatsApp,
}

export enum BrandReferralConfigChannels {
  SMS = Channels.SMS,
  Email = Channels.Email,
}

export enum KycDocumentOptions {
  Passport = 1,
  IDCard = 2,
  DrivingLicense = 4,
  Selfie = 8,
  BankCard = 16,
  UtilityBills = 32,
  TaxBills = 64,
  BankStatement = 128,
  RentAgreement = 256,
  InsuranceAgreement = 512,
  ResidencyCard = 1024,
  PaymentMethod = 2048,
  Other = 4096,
  IncomeFromEmployment = 8192,
  IncomeFromInvestments = 16384,
  IncomeFromSales = 32768,
  ProofOfInheritance = 65536,
  SpecialPermitOfStay = 131072,
  TemporaryProtectionPermit = 262144,
}

export enum KycDocumentStates {
  Pending = 1,
  InProcess = 2,
  Approved = 3,
  Rejected = 4,
  Verified = 5,
  Archived = 6,
  Expired = 7,
  Deleted = 8,
}

export enum PaymentRequestStatuses {
  Initialized = 0,
  Pending = 1,
  InProcess = 2,
  CancelledByUser = 3,
  CancelledByPlayer = 4,
  Failed = 5,
  Declined = 7,
  Frozen = 8,
  PayPending = 9,
  Paid = 10,
  OnHold = 11,
}

export enum BrandAutomationConditionPeriodType {
  OneHour = 1,
  SixHours = 2,
  TwelveHours = 3,
  OneDay = 4,
  SevenDays = 5,
  ThirtyDays = 6,
  TwoMonths = 7,
  Lifetime = 8,
  LastOneHour = 10,
  LastFourHours = 15,
  LastSixHours = 20,
  LastTwelveHours = 30,
  LastOneDay = 40,
  LastSevenDays = 50,
  LastThirtyDays = 60,
  LastTwoMonths = 70,
  LastThreeMonths = 75,
  LastSixMonths = 80,
  LastTwelveMonths = 90,
  OneCalendarDay = 100,
  SevenCalendarDays = 110,
  ThirtyCalendarDays = 120,
  TwoCalendarMonths = 130,
}

export enum PlayerStatuses {
  Active = 1,
  Blocked = 2,
  BlockedForSport = 4,
  BlockedForCasino = 8,
  BlockedForWithdrawals = 16,
  BlockedForDeposits = 64,
  BlockedForUnverified = 128,
}

export enum BonusCommonStatuses {
  Scheduled = 1,
  Active = 2,
  Disabled = 3,
  Finished = 4,
}

export enum CashbackTypes {
  Fixed = 1,
  Dynamic = 2,
  Series = 3,
}

export enum CashbackTransferTypes {
  Automatic = 1,
  Manual = 2,
}

export enum CashbackCalculationFrom {
  FromBets = 1,
  FromNetDeposits = 2,
}

export enum CashbackV2CalculationFrom {
  Bets = 3,
  NetDeposits = 4,
}

export enum CashbackV2WinTypes {
  RealMoney = 1,
  Bonus = 2,
}

export enum CashbackV2PrizeTypes {
  Fixed = 1,
  Percent = 2,
}

export enum CashbackParticipateRules {
  ExcludePlayersNegativeLifetimeNet = 1,
  IncludeBonusRedeems = 2,
  IncludeRealMoneyBonuses = 4,
}

export enum CashbackV2ParticipateRules {
  ExcludePlayersNegativeLifetimeNet = 1,
  IncludeBonusRedeems = 2,
  IncludeRealMoneyBonuses = 4,
}

export enum CampaignV2SportBonusBetTypes {
  Single = 1,
  Multi = 2,
  SingleAndMulti = 3,
}

export enum CampaignV2SportEventTypes {
  PreMatch = 1,
  Live = 2,
  All = 3,
}

export enum CampaignV2SportBetBuilderTypes {
  All = 1,
  OnlyBetBuilder = 2,
  WithoutBetBuilder = 3,
}

export enum SportTreeRuleInvolvements {
  Include = 1,
  Exclude = 2,
}

export enum BrandAutomationPeriod {
  None = 0,
  Hour = 1,
  Hours6 = 2,
  Hours12 = 3,
  Day = 4,
  Days7 = 5,
  Days30 = 6,
  Months2 = 7,
  Months3 = 8,
  Months6 = 9,
}

export enum SportPlayerStatus {
  Common = 1,
  New = 2,
  Female = 3,
  VipUser = 4,
  Terminal = 5,
  Arbitage = 6,
  Problem = 7,
  Special = 8,
  Marker = 9,
  TradingAnalysing = 10,
  LateBetting = 11,
  Middler = 12,
  Betshop = 13,
  Professional = 14,
  HighValue = 15,
  VipSpecial = 16,
  BonusHunter = 17,
  Capper = 18,
  Inactive = 19,
  LowGgr = 20,
  VipPlatinum = 21,
  GoodGuys = 25,
  VipBronze = 26,
  VipSilver = 27,
  VipGold = 28,
  VipUltra = 29,
}

export enum DeviceTypes {
  Other = 1,
  WebDesktop = 4,
  WebMobile = 8,
  Android = 64,
  Ios = 128,
  PwaApp = 2048,
  TV = 8192,
}

export enum BrandAutomationRevenueOperationType {
  Win = 1,
  CashBack = 2,
  ReferralCommission = 3,
  Jackpot = 4,
  TournamentPrize = 5,
  BonusRedeem = 6,
  GeneralCorrection = 7,
}

export enum BrandAutomationManageWithdrawal {
  Approve = 1,
  Decline = 2,
  Freeze = 3,
  Cancel = 4,
}

export enum BrandAutomationManageDeposit {
  Approve = 1,
  Decline = 2,
  StartProcess = 3,
}

export enum BrandAutomationAccountFields {
  Citizenship = 1,
}

export enum BooleanType {
  No = 0,
  Yes = 1,
}

export enum BrandAutomationOperator {
  In = 1,
  NotIn = 2,
  Equals = 3,
  Greater = 4,
  Less = 5,
  GreaterOrEqual = 6,
  LessOrEqual = 7,
  Between = 8,
  All = 9,
  Any = 10,
  NotAny = 11,
}

export enum LogicTypes {
  Real = 1,
  Bonus = 2,
}

export enum BetTypes {
  Casino = 1,
  Sport = 2,
}

export enum BrandAutomationType {
  PerformedWithdrawals = 1,
  PerformedDeposits = 2,
  PerformedBets = 3,
  Revenue = 4,
  WithdrawalTransaction = 5,
  SignUp = 6,
  Verify = 7,
  UnVerify = 8,
  AccountUpdate = 9,
  SignIn = 10,
  DepositTransaction = 11,
  NoTrigger = 12,
}

export enum BrandAutomationConditionType {
  PaymentMethod = 1,
  PaymentRestrictions = 2,
  Amount = 3,
  Country = 4,
  Verification = 5,
  AccountStatus = 6,
  SportStatus = 7,
  Segment = 8,
  Tag = 10,
  GGR = 11,
  NGR = 12,
  SuccessfulWithdrawalsAmount = 13,
  FailedWithdrawalsAmount = 14,
  DepositsAmount = 15,
  FailedDepositsAmount = 16,
  SuccessfulDepositsCount = 17,
  FailedDepositsCount = 18,
  SuccessfulWithdrawalsCount = 19,
  FailedWithdrawalsCount = 20,
  CasinoBetCount = 21,
  SportBetCount = 22,
  PeriodCount = 23,
  PeriodAmount = 24,
  TransactionType = 25,
  GameCategory = 26,
  Balance = 27,
  DelayForPerformedWithdrawals = 28,
  SignUpDevice = 29,
  Btag = 30,
  Citizenship = 31,
  NetCashAmount = 33,
  LastSuccessfulDeposit = 34,
  CasinoSportBetComparison = 35,
  Age = 36,
  BetAmount = 37,
  SessionDuration = 38,
  GGRPercentage = 39,
  NGRPercentage = 40,
  BetPercentage = 41,
  PaymentMethodCount = 42,
  DepositPercentage = 43,
  PlayerLimitChangingCount = 44,
  PlayerLimitIncreasePercentage = 45,
  PlayerRegistrationDate = 46,
  BtagValues = 47,
}

export enum BrandAutomationActionType {
  ManageWithdrawalTransaction = 1,
  SendEmail = 2,
  Segment = 3,
  HorizontalTag = 4,
  VerticalTag = 5,
  SendMassMessage = 6,
  TagTransaction = 7,
  ManageDepositTransaction = 8,
  BlockActivities = 9,
}

export enum AgDataStatuses {
  Pending = 1,
  Fail = 2,
  Success = 3,
}

export enum ReleaseNoteLabels {
  Bug = 1,
  Improvement = 2,
  Feature = 3,
}

export enum Genders {
  Male = 1,
  Female = 2,
  PreferNotSay = 4,
  Other = 8,
}

export enum BrandStatuses {
  Active = 1,
  Disabled = 2,
  ActivitiesDisabled = 3,
  VersionNamesDisabled = 4,
  Maintenance = 5,
}

export enum OperationalLimitsTypes {
  BetStatusCorrections = 1,
  BalanceAdjustments = 2,
  BonusGranting = 3,
}

export enum PermissionSecurityLevel {
  Lowest = 1,
  Low = 2,
  Medium = 3,
  High = 4,
  Higher = 5,
  VeryHigh = 6,
  Maximum = 7,
}

export enum AccessManagementRequestStatuses {
  Pending = 1,
  Approved = 2,
  Declined = 3,
  Cancelled = 4,
}

export enum AccessManagementObjectTypes {
  User = 1,
  PermissionGroup = 2,
}

export enum AccessManagementActionTypes {
  AssignPermissionGroupToUser = 1,
  UpdateUserAccess = 2,
  CreatePermissionGroup = 3,
  ModifyPermissionGroup = 4,
}

export const systemPartnerId = 1;

export enum BetStates {
  New = 1,
  Won = 2,
  Lost = 3,
  Cancelled = 4,
  CashOut = 5,
}

export enum RoundStates {
  New = 1,
  Won = 2,
  Lost = 3,
  Cancelled = 4,
}

export enum BulkBetCorrectionStatuses {
  InProgress = 1,
  Failed = 2,
  Success = 3,
}

export enum BetCorrectionType {
  Refund = 1,
  WinLost = 2,
}

export enum SportBetProcessingTypes {
  Standard = 0,
  AutoBet = 1,
  MegaBet = 2,
}

export enum AllDeviceTypes {
  Unknown = 1,
  Betshop = 2,
  WebDesktop = 4,
  WebMobile = 8,
  Wap = 16,
  Terminal = 32,
  Android = 64,
  Ios = 128,
  POS = 256,
  LiteBet = 512,
  WebOldMobile = 1024,
  PwaApp = 2048,
  TV = 8192,
}

export enum WalletTypes {
  Rollover = 1,
  Unused = 2,
  Used = 3,
  Bonus = 4,
  Booked = 5,
  Debt = 6,
  SportBonus = 90,
}

export enum TestPlayerAccountTypes {
  Temporary = 1,
  Permanent = 2,
}

export enum TestPlayerAccountStatuses {
  Free = 1,
  Busy = 2,
  Closed = 3,
}

export enum PoliticallyExposedPerson {
  None = 0,
  Domestic = 1,
  Foreign = 2,
  International = 3,
}

export enum EddVerificationOptions {
  NotRequired = 1,
  Required = 2,
  Pending = 3,
  Unverified = 4,
  Verified = 5,
}

export enum BirthDateTypes {
  Year = 1,
  FullDate = 2,
}

export enum ExclusionLimitState {
  Inactive = 0,
  Active = 1,
}

export enum LobbyWidgetTypes {
  GameWidget = 1,
  GroupWidget = 2,
  ProviderWidget = 3,
  ActionLinkWidgets = 4,
  TopWinWidget = 5,
  TopXWidget = 6,
  RandomGameWidget = 7,
  ProvidersAndGamesWidget = 8,
  SingleGameWidget = 9,
  JackpotWidget = 10,
  ImgWidget = 11,
  CollectionWidget = 12,
  BannerWidget = 13,
  StoryWidget = 14,
  SearchBox = 15,
  LastPlayedWidget = 16,
  FavoriteWidget = 17,
  CountdownWidget = 18,
  TournamentWidget = 19,
}

export enum LobbyGridTypes {
  Standard = 1,
  Advanced = 2,
  Special = 3,
  Vertical = 4,
}

export enum LobbyProvidersPositions {
  ExtendedTab = 1,
  Slider = 2,
  DropDown = 3,
}

export enum LobbyWidgetDeviceTypes {
  All = 1,
  Mobile = 2,
  Desktop = 3,
}

export enum LobbyWidgetSectionTypes {
  Home = 1,
  Navigation = 2,
}

export enum LobbyTypes {
  Casino = 1,
  LiveCasino = 2,
  VirtualSports = 4,
  TVGames = 8,
  SkillGames = 16,
}

export enum LobbyWidgetGridTypes {
  Standard = 1,
  Advanced = 2,
  Vertical = 3,
  Horizontal = 4,
}

export enum LobbyGamesViewTypes {
  GameDetailsPreview = 1,
  GameDetailsCard = 2,
}

export enum LobbyProvidersViewTypes {
  Text = 1,
  Logo = 2,
}

export enum LobbyGroupsViewTypes {
  Text = 1,
  Icon = 2,
}

export enum LobbyGameDetailsOnHoverTypes {
  GameName = 1,
  ProviderName = 2,
}

export enum LobbyDemoButtonDeviceTypes {
  Mobile = 1,
  Desktop = 2,
}

export enum LobbyFilterTypes {
  Theme = 1,
  StakeRange = 2,
  Features = 4,
  Volatility = 8,
}

export enum WidgetGameSelectionTypes {
  GameUpload = 1,
  GroupSelection = 2,
  Custom = 3,
}

export enum RequestMethods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum EpisLogResourceTypes {
  Login = 1,
  Registration = 2,
}

export enum EpisLogStatuses {
  Successful = 1,
  Failed = 2,
}

export enum PaymentRefundStatuses {
  NotRefunded = 0,
  Initiated = 1,
  InProcess = 2,
  Success = 3,
  Failed = 4,
}

export enum PlayerBonusV2Statuses {
  New = 1,
  Active = 2,
  Finished = 3,
  Canceled = 4,
  Expired = 5,
  Pending = 6,
}

export enum PlayerVerificationFlows {
  InternalDocuments = 1,
  KycAid = 2,
  Metamap = 3,
  GhanaRegulation = 4,
  BecomeDigital = 5,
  ItsMe = 6,
  Authentigate = 7,
  Trustly = 8,
  Unico = 9,
  GBG = 10,
}

export enum GamificationSpinDistributingTypes {
  FreeActivation = 1,
  Deposit = 2,
  ActivationOnCollect = 3,
  Bet = 4,
  BuyActivation = 5,
}

export enum GamificationTriggerOptions {
  Every = 1,
  NumberOf = 2,
  Cumulative = 3,
}

export enum GamificationTriggerPeriodTypes {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  PromotionPeriod = 4,
  Lifetime = 5,
}

export enum SportBetTypes {
  Single = 1,
  System = 2,
  Express = 3,
}

export enum ExpressOddTypes {
  Total = 1,
  Minimum = 2,
}

export enum MaxExpressOddTypes {
  Total = 1,
  Maximum = 3,
}

export enum BetWalletTypes {
  Rollover = 1,
  Unused = 2,
  Used = 3,
  Booked = 5,
  Debt = 6,
  FreeBetCasino = 501,
  FreeBetSport = 502,
  SportWager = 503,
  CasinoWager = 504,
  MixWager = 505,
}

export enum SportBonusBetType {
  Single = 2,
  Multi = 3,
  Express = 1,
}

export enum GamificationStatuses {
  Draft = 1,
  Scheduled = 2,
  Active = 3,
  Finished = 4,
}

export enum GamificationConditionTypes {
  AllPlayers = 1,
  Condition = 2,
  // SelectedPlayers= 2,
}

export enum CampaignConditionTypes {
  Country = 1,
  Payments = 2,
  Verify = 3,
  WeekDays = 4,
  AccountStatus = 5,
  SportStatus = 6,
  Segment = 7,
  Tag = 8,
  TriggerDeviceType = 9,
  SignUpDeviceType = 10,
  MonthlyDates = 11,
}

export enum GamificationParticipantTypes {
  Public = 1,
  Private = 2,
}

export enum GamificationPrizeTypes {
  TryAgain = 1,
  Bonus = 2,
  Material = 3,
  MachineSpin = 4,
  BalanceMultiplier = 5,
}

export enum GamificationMachineTypes {
  Wheel = 1,
  Grid = 2,
  Box = 3,
}

export enum GamificationGroupTypes {
  Diamond = 1,
  Platinum = 2,
  Gold = 3,
  Silver = 4,
  Bronze = 5,
}

export enum GamificationGroupLimitPeriodTypes {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  AllPeriod = 4,
}

export enum GamificationContentGenerationTypes {
  Promotion = 1,
  Machine = 2,
  SpinDistribution = 3,
  Prize = 4,
}

export enum GamificationPageBackgroundFitTypes {
  Fill = 1,
  Repeat = 2,
  Fit = 3,
}

export enum GamificationPageBackgroundPositionTypes {
  Standard = 1,
  Fixed = 2,
}

export enum GamificationContentTypes {
  Default = 1,
  Currency = 2,
}

export enum GamificationPrizeStatuses {
  New = 1,
  Received = 2,
  Pending = 3,
  Cancelled = 4,
}

export enum GamificationChosenMaterialPrizeTypes {
  Material = 1,
  Amount = 2,
}

export enum GamificationMaterialPrizeActions {
  Approve = 1,
  Decline = 2,
  Cancel = 3,
}

export enum GamificationSpinProvisionTypes {
  System = 1,
  Manual = 2,
}

export enum GamificationSectionTypes {
  MainSettings = 1,
  Prize = 2,
  MachineConfig = 3,
  GroupLimit = 4,
}

export enum KycDocumentTypes {
  Identity = 1,
  UtilityBill = 2,
  Other = 3,
  Citizenship = 4,
  Edd = 5,
}

export enum BrandStandardSettingsCategories {
  All = 0,
  Website = 1,
  Procedures = 2,
  Shared = 3,
}

export enum BrandVerificationDocumentTypes {
  Passport = 'passport',
  IdCard = 'idCard',
  DrivingLicense = 'drivingLicense',
  Selfie = 'selfie',
  BankCard = 'bankCard',
  UtilityBills = 'utilityBills',
  TaxBills = 'taxBills',
  BankStatement = 'bankStatement',
  RentAgreement = 'rentAgreement',
  InsuranceAgreement = 'insuranceAgreement',
  ResidencyCard = 'residencyCard',
  PaymentMethod = 'paymentMethod',
  IncomeFromEmployment = 'incomeFromEmployment',
  IncomeFromInvestments = 'incomeFromInvestments',
  IncomeFromSales = 'incomeFromSales',
  ProofOfInheritance = 'proofOfInheritance',
  SpecialPermitOfStay = 'specialPermitOfStay',
  TemporaryProtectionPermit = 'temporaryProtectionPermit',
  Other = 'other',
}

export enum WebsiteWalletTypes {
  Used = 1,
  Unused = 2,
  Rollover = 4,
  Withdrawable = 8,
  BonusBalance = 16,
  FreeBetCount = 32,
  FreeSpinCount = 64,
  RealBalance = 128,
}

export enum TransactionsHistoryTypes {
  BalanceAdjustment = 0,
  ReferrerHistory = 1,
  Cashback = 2,
  SportJackpot = 3,
  Bonuses = 4,
  BuyPromoSpin = 5,
  CasinoJackpot = 6,
  CasinoTax = 7,
  Deposit = 8,
  Withdrawal = 10,
  PendingWithdrawal = 11,
}

export enum OtpDeliveryMethods {
  Sms = 1,
  Telegram = 2,
}

export enum BrandVerificationTypes {
  None = 0,
  VerifyEmailOnLogin = 1,
  VerifyMobileOnLogin = 2,
}

export enum InactivePeriodMonths {
  Months3 = 3,
  Months6 = 6,
  Months12 = 12,
  Months24 = 24,
}

export enum InactivityTriggerTypes {
  None = 0,
  Login = 1,
  Transaction = 2,
}

export enum BrandVerificationPeriods {
  FirstDepositDate = 0,
  RegistrationDate = 1,
}

export enum EpisPlayerStates {
  Registered = 2,
  Validated = 3,
}

export enum PlayerActions {
  EndSession = 0,
  BlockSportsbook = 1,
  BlockCasino = 2,
  BlockWithdrawals = 4,
  BlockAccount = 5,
  BlockMessages = 6,
  Unblock = 7,
  MarkAttention = 8,
  RemoveAttention = 9,
  Unlock = 10,
  AccountClosure = 11,
  Inactive = 12,
  Activate = 13,
  Lock = 14,
  Blacklist = 15,
  Whitelist = 16,
  BlockDeposits = 19,

  UnblockWithdrawals = 17,
  UnblockDeposits = 18,
  UnblockMessages = 20,
  DisableLogin2FA = 21,
  EnableLogin2FA = 22,
  BlockUnverify = 23,
  UnblockUnverify = 24,
  SetOTP = 25,
  NraRestricted = 28,
  NraRestored = 29,

  UnblockSportsbook = 1000,
  UnblockCasino = 1001,
  UnblockTransactions = 1002,
  UnblockAccount = 1003,
  VerifyEmail = 1004,
  UnVerifyEmail = 1005,
  VerifyIdentity = 1006,
  UnVerifyIdentity = 1007,
  VerifyMobile = 1008,
  UnVerifyMobile = 1009,
  VerifyAddress = 1010,
  UnVerifyAddress = 1011,
  CompletePhysicalVerification = 1012,
  IncompletePhysicalVerification = 1013,
  VerifyCitizenship = 1014,
  UnVerifyCitizenship = 1015,
  BlockActivities = 1016,
  UnblockActivities = 1017,
}

export enum PlayerBlockActions {
  SportBooks = 1,
  Casino = 2,
  Withdrawals = 4,
  Deposit = 8,
  Messages = 32,
  Account = 64,
  Unverified = 128,
}

export enum ProviderActionTypes {
  Block = 1,
  Unblock = 2,
}

export enum PaymentMethodActionTypes {
  Block = 1,
  Unblock = 2,
}

export enum ThirdPartyServiceTypes {
  GamStop = 1,
  GBG = 2,
  MetaMap = 3,
}

export enum GamStopExclusionStatuses {
  None = 0,
  Excluded = 1,
  NotExcluded = 2,
  Pending = 3,
}

export enum GamStopCallTypes {
  Single = 1,
  Batch = 2,
}

export enum PushNotificationStatuses {
  Sent = 3,
  Failed = 4,
  Scheduled = 5,
  Sending = 6,
  Preparing = 7,
}
export enum PlayerPushNotificationStatuses {
  Failed = 1,
  Scheduled = 2,
  Sent = 3,
  Read = 4,
  Expired = 5,
}

export enum DeepLinkSections {
  Login = 1,
  Registration = 2,
  MyProfile = 3,
  Deposit = 4,
  Withdrawal = 5,
  Casino = 6,
  Sport = 7,
  InboxMessages = 8,
  Verification = 9,
  OffersSport = 10,
  OffersCasino = 11,
  PromoCodes = 12,
  Tournament = 13,
  EventId = 14,
  CasinoProvider = 15,
  LiveCasinoProvider = 16,
  TVGames = 17,
  VirtualSport = 18,
  CasinoGame = 19,
  CustomPage = 20,
  SportsPrematch = 21,
  SportsLive = 22,
  EsportMain = 23,
  BetRace = 24,
  CasinoLobbyGamesGroup = 25,
  LiveCasinoLobbyGamesGroup = 26,
  TVGamesLobbyGamesGroup = 27,
  FastGamesLobbyGamesGroup = 28,
  VirtualSportLobbyGamesGroup = 29,
  LiveCasinoGame = 30,
  TVGamesGame = 31,
  VirtualSportGame = 32,
  FastGamesGame = 33,
  Gamification = 34,
}

export enum PushNotificationRecipients {
  Active = 1,
  Guest = 2,
  All = 3,
}

export enum InboxStatuses {
  New = 1,
  SendByUser = 2,
  ReadByPlayer = 3,
  Deleted = 4,
}

export enum SenderTypes {
  Player = 0,
  System = 1,
  User = 2,
}

export enum NotificationProductTypes {
  Sport = 1,
  Casino = 2,
  Other = 3,
}

export enum NotificationTypes {
  Sms = 1,
  Email = 2,
  PushNotification = 4,
}

export enum SmsProviders {
  AfricasTalking = 1,
  Gateway = 2,
  Twilio = 3,
  Blackbox = 4,
  MobiPace = 5,
  Nikita = 6,
  Dexatel = 7,
  Orchard = 8,
  BudgetSMS = 9,
  SmartSMSSolutions = 10,
  betaSMS = 11,
  RPMMobile = 12,
  InfoBip = 13,
  iCell = 14,
  Mobivate = 15,
  Wolkvox = 16,
  BytePlus = 17,
  Laaffic = 18,
  LinkMobility = 19,
  LotoBet = 20,
  UQMobile = 21,
}

export enum SmtpProviders {
  Digitain = 1,
  Custom = 2,
  SendGrid = 4,
}

export enum BrandAutomationPeriodOptions {
  Period = 1,
  TimeRange = 2,
}

export enum DashboardIcons {
  FinancialIcon = 1,
  AnalyticsIcon = 2,
  PlayersIcon = 3,
  CasinoIcon = 4,
  SportTennisIcon = 5,
  BonusEngineIcon = 7,
  OtherIcon = 6,
}

export enum DashboardWidgetChartType {
  LineChart = 1,
  BarChart = 2,
  ColumnChart = 3,
  PieChart = 4,
  AreaChart = 5,
  StackedBarChart = 6,
  NumericWidget = 7,
}

export enum DashboardWidgetAggregationCriteria {
  Country = 1,
  PaymentMethod = 2,
  Game = 3,
  Provider = 4,
  DeviceType = 5,
  Category = 6,
  Status = 7,
  BonusType = 8,
  BonusFamily = 9,
  City = 10,
}

export enum DashboardValueTypes {
  Amount = 1,
  Count = 2,
}

export enum DashboardWidgetPeriod {
  Today = 1,
  Yesterday = 14,
  CurrentWeek = 2,
  LastWeek = 3,
  CurrentMonth = 4,
  LastMonth = 5,
  LastQuarter = 6,
  CurrentQuarter = 7,
  CurrentYear = 8,

  YearPeriod = 9,
  Last6MonthPeriod = 10,
  QuarterPeriod = 11,
  MonthPeriod = 12,
  WeekPeriod = 13,
}

export enum DashboardWidgetDataType {
  Registrations = 1,
  Sessions = 2,
  DistinctSessions = 4,
  NewDepositors = 8,
  Referees = 16,
  TotalBonuses = 32,
  TotalRedeem = 64,
  TotalBets = 128,
  Wins = 256,
  Ggr = 512,
  Ngr = 1024,
  Deposits = 2048,
  Withdrawals = 4096,
  Hold = 8192,
  NewBets = 16384,
  LostBets = 32768,
  CancelledBets = 65536,
}

export enum PlayerBonusStatuses {
  New = 1,
  Active = 2,
  Finished = 3,
  Canceled = 4,
  Expired = 5,
  Pending = 6,
  Paused = 7,
}

export enum DashboardWidgetLimitType {
  Top = 1,
  Bottom = 2,
  Custom = 3,
}

export enum DashboardAggregationPeriodBy {
  SemiAnnual = 1,
  Quarterly = 2,
  Monthly = 3,
  Weekly = 4,
  Daily = 5,
}

export enum GoogleAdsConversionEventType {
  Registration = 1,
  FTD = 2,
  Deposit = 3,
}

export enum CampaignV2GameTypes {
  All = 1,
  Custom = 2,
  Segments = 3,
}

export enum OddsFormat {
  Decimal = 0,
  American = 1,
}

export enum PromotionalItemStatus {
  Active = 1,
  Finished = 2,
}

export enum BrandAutomationLimitChangeType {
  Increase = 1,
  Decrease = 2,
  Both = 3,
}

export enum CampaignV2Operators {
  In = 1,
  NotIn = 2,
  All = 3,
}

export enum PlayerConditionType {
  Segment = 1,
  Tag = 2,
}

export enum NraStatus {
  None = 0,
  Restricted = 1,
  NotRestricted = 2,
}

export enum SelfieKycStatus {
  None = 0,
  Success = 1,
  Rejected = 2,
}

export enum NraCallType {
  Registration = 1,
  Login = 2,
  Batch = 3,
}

export enum RewardTypes {
  Bonus = 1,
  Commission = 2,
}

export enum ReferralBonusType {
  Dynamic = 1,
  Progressive = 2,
  Prize = 3,
}

export enum ReferralFinancialActivity {
  Deposits = 0,
  Bets = 1,
  GGR = 2,
  NGR = 3,
}

export enum ReferralRefereesType {
  All = 1,
  New = 2,
}

export enum ReferralActivities {
  SignUp = 0,
  Verification = 1,
  Deposit = 2,
  Bet = 3,
}

export enum ReferralBonusAmount {
  PerReferee = 0,
  AllReferees = 1,
}

export enum CashBackReferralPeriodStatus {
  Accumulated = 1,
  Transferred = 2,
  Failed = 3,
}

export enum ReferralCalculationPeriod {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
}

export enum CashbackTransferType {
  Manual = 2,
  Automatic = 1,
}

export enum ReferralParticipationTypes {
  AllPlayers = 1,
  CustomSelection = 2,
}

export enum Periods {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
}

export enum SimilarAccountDetectionArea {
  Session = 1,
  Registration = 2,
}

export enum SimilarAccountParameterType {
  Ip = 1,
  DeviceId = 2,
  BrowserFamily = 3,
}

export enum TransactionTypes {
  CreditToClient = -1,
  DebitFromClient = 1,
}

export enum AdjustmentOperationTypes {
  ReferralCommission = 1,
  Cashback = 3,
  Correction = 4,
  TournamentPrize = 5,
  Deposit = 6,
  Withdrawal = 7,
  Jackpot = 8,
  TaxOnDeposit = 9,
  TaxOnWithdrawal = 10,
  DebtBalance = 11,
  TaxOnBetProfit = 12,
  TestMoney = 13,
  ForcedComplianceBlock = 14,
  GrantedRealMoney = 15,
  FreeSpinRedeemCancel = 17,
}

export enum RegulatorySystemErrorReportTypes {
  ApplicationError = 1,
  InternalError = 2,
  ServerError = 3,
  AccessError = 4,
  StorageError = 5,
}

export enum CumulativeTaxCalculationTypes {
  Relative = 1,
  EntireAmount = 2,
}

export enum ReportBetTypes {
  Real = 1,
  Bonus = 2,
  Mixed = 3,
}

export enum BrandExportCenterReportTypes {
  Casino = 1,
  Sport = 2,
  Deposit = 3,
  Withdrawal = 4,
}

export enum LobbyWidgetOperators {
  In = 1,
  NotIn = 2,
  All = 99,
}

export enum RegulatoryServerNameTypes {
  Main = 1,
  MirrorServer = 2,
  Website = 3,
  SafeServer = 4,
  Replication = 5,
  Backup = 6,
  Reporting = 7,
}

export enum TopWinnerWidgetTypes {
  Standard = 1,
  Highlighted = 2,
}

export enum LobbyWidgetTopWinsTypes {
  DailyWins = 1,
  MonthlyWins = 2,
  MyWins = 3,
}

export enum CashbackAdjustmentOperatorTypes {
  Increase = 1,
  Decrease = 2,
}

export enum CashbackV2AccumulatedActionTypes {
  Send = 1,
  Delete = 2,
  Adjust = 3,
}

export enum BonusReportAggregationTypes {
  Brand = 0,
  BonusType = 1,
  TriggerType = 2,
  Product = 3,
  Player = 4,
  Status = 5,
  Unit = 6,
  Campaign = 7
}

export enum SelfExclusionPeriods {
  None = 0,
  Months2 = 1,
  Months3 = 2,
  Months6 = 3,
  Months8 = 4,
  Year1 = 5,
  Years2 = 6,
  Years5 = 7,
  Years3 = 8,
  Week1 = 9,
  Months1 = 10,
  Indefinite = 100,
}

export enum ExclusionPeriodTypes {
  Temporary = 1,
  Permanent = 2,
}

export enum ExclusionPerformedByTypes {
  Admin = 0,
  Player = 1,
  System = 2,
}

export enum ActionStatuses {
  Failed = 1,
  InProcess = 2,
  Success = 3,
}

export enum RegistrationUniquenessTypes {
  FirstName = 1,
  LastName = 2,
  Birthday = 4,
}

export enum PlayerContactInfoVerificationTypes {
  Email = PlayerVerification.Email,
  Mobile = PlayerVerification.Mobile,
}

export enum TranslationsDefaultSectionGroups {
  MainContent = 0,
  ErrorMessages = 1,
  ReasonsContent = 3,
}

export enum PromoCodeV2Types {
  Single = 0,
  Multiple = 1,
  External = 2,
}

export enum GameState {
  New = 7,
  Promo = 8,
}

export enum SportsBookReasons {
  Malfunction = 1,
  Maintenance = 2,
  ContractIssue = 3,
  Other = 4,
}

export enum GameGroupTypes {
  System = 1,
  Custom = 2,
  ZingBrain = 3,
  BiRecommendation = 4,
}

export enum GameOrderTypes {
  GGR = 1,
  PlayedRounds = 2,
  Likes = 3,
  Name = 4,
  CreationDate = 5,
  DistinctPlayerCount = 6,
  Favorites = 7,
  CustomOrdering = 8,
}

export enum JackpotFeedTypes {
  Single = 1,
  Multi = 2,
}

export enum ZingRecommendationType {
  RecommendedGames = 1,
  NewGames = 2,
  NewToPlayerGames = 3,
  TrendingGames = 4,
  ForgottenFavoriteGames = 5,
  FavoriteGames = 6,
  FavoriteMechanicGames = 7,
  FavoriteProviderGames = 8,
  TopLocalGames = 9,
  PerGame = 10,
}

export enum FacialRecognitionRequirements {
  PlayerInformationUpdate = 0,
  UsernamePasswordRecovery = 1,
  FailedLoginAttempt = 2,
  AccountClosure = 3,
}

export enum Occupations {
  SelfEmployed = 1,
  EmployedWorker = 2,
  IndependentProfessional = 3,
  Student = 4,
  Retired = 5,
  Trainee = 6,
  WithoutProfessionalActivity = 7,
  Unemployed = 8,
  Other = 9,
}

export enum GameFeature {
  DemoPlay = 1,
  BuyBonus = 2,
  Jackpot = 4,
  FreeGame = 8,
  Megaways = 16
}

export enum InactivePlayerMoneyTransferTypes {
  None = 1,
  Government = 2,
  Player = 3,
}
